import React from "react";
import clsx from "clsx";
import { dictionary, dictionaryKeys } from "../../common/internationalization";

function Icon({
  children,
  className,
  fill = "currentColor",
  stroke,
  viewBox,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      {...props}
      fill={fill}
      stroke={stroke}
      className={clsx("icon", className)}
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

export function IconLinkedIn(props) {
  return (
    <Icon {...props}>
      <title>LinkedIn</title>
      <path
        d="M20.4705 2.00014H3.53055C3.34013 1.9975 3.15105 2.03239 2.97411 2.10282C2.79718 2.17326 2.63585 2.27786 2.49934 2.41065C2.36284 2.54344 2.25383 2.70182 2.17854 2.87675C2.10325 3.05167 2.06316 3.23972 2.06055 3.43014V20.5701C2.06316 20.7606 2.10325 20.9486 2.17854 21.1235C2.25383 21.2985 2.36284 21.4568 2.49934 21.5896C2.63585 21.7224 2.79718 21.827 2.97411 21.8975C3.15105 21.9679 3.34013 22.0028 3.53055 22.0001H20.4705C20.661 22.0028 20.85 21.9679 21.027 21.8975C21.2039 21.827 21.3652 21.7224 21.5017 21.5896C21.6383 21.4568 21.7473 21.2985 21.8226 21.1235C21.8978 20.9486 21.9379 20.7606 21.9405 20.5701V3.43014C21.9379 3.23972 21.8978 3.05167 21.8226 2.87675C21.7473 2.70182 21.6383 2.54344 21.5017 2.41065C21.3652 2.27786 21.2039 2.17326 21.027 2.10282C20.85 2.03239 20.661 1.9975 20.4705 2.00014ZM8.09055 18.7401H5.09055V9.74014H8.09055V18.7401ZM6.59055 8.48014C6.17681 8.48014 5.78002 8.31578 5.48746 8.02323C5.1949 7.73067 5.03055 7.33388 5.03055 6.92014C5.03055 6.5064 5.1949 6.10961 5.48746 5.81705C5.78002 5.5245 6.17681 5.36014 6.59055 5.36014C6.81024 5.33522 7.03272 5.35699 7.24342 5.42402C7.45412 5.49105 7.64829 5.60183 7.8132 5.7491C7.97812 5.89637 8.11007 6.07682 8.20042 6.27862C8.29076 6.48043 8.33746 6.69904 8.33746 6.92014C8.33746 7.14124 8.29076 7.35985 8.20042 7.56166C8.11007 7.76346 7.97812 7.94391 7.8132 8.09118C7.64829 8.23845 7.45412 8.34923 7.24342 8.41626C7.03272 8.48329 6.81024 8.50505 6.59055 8.48014ZM18.9105 18.7401H15.9105V13.9101C15.9105 12.7001 15.4805 11.9101 14.3905 11.9101C14.0532 11.9126 13.7247 12.0184 13.4494 12.2133C13.174 12.4082 12.965 12.6828 12.8505 13.0001C12.7723 13.2352 12.7384 13.4827 12.7505 13.7301V18.7301H9.75055C9.75055 18.7301 9.75055 10.5501 9.75055 9.73014H12.7505V11.0001C13.0231 10.5272 13.4195 10.1377 13.897 9.87334C14.3745 9.60902 14.9151 9.47999 15.4605 9.50014C17.4605 9.50014 18.9105 10.7901 18.9105 13.5601V18.7401Z"
        fill="currentColor"
      />
    </Icon>
  );
}

export function IconEmail(props) {
  return (
    <Icon {...props}>
      <title>{dictionary(dictionaryKeys.IconEmail)}</title>

      <path
        d="M19 4H5C4.20435 4 3.44129 4.31607 2.87868 4.87868C2.31607 5.44129 2 6.20435 2 7V17C2 17.7956 2.31607 18.5587 2.87868 19.1213C3.44129 19.6839 4.20435 20 5 20H19C19.7956 20 20.5587 19.6839 21.1213 19.1213C21.6839 18.5587 22 17.7956 22 17V7C22 6.20435 21.6839 5.44129 21.1213 4.87868C20.5587 4.31607 19.7956 4 19 4ZM5 6H19C19.2652 6 19.5196 6.10536 19.7071 6.29289C19.8946 6.48043 20 6.73478 20 7L12 11.88L4 7C4 6.73478 4.10536 6.48043 4.29289 6.29289C4.48043 6.10536 4.73478 6 5 6ZM20 17C20 17.2652 19.8946 17.5196 19.7071 17.7071C19.5196 17.8946 19.2652 18 19 18H5C4.73478 18 4.48043 17.8946 4.29289 17.7071C4.10536 17.5196 4 17.2652 4 17V9.28L11.48 13.85C11.632 13.9378 11.8045 13.984 11.98 13.984C12.1555 13.984 12.328 13.9378 12.48 13.85L20 9.28V17Z"
        fill="currentColor"
      />
    </Icon>
  );
}

export function IconFacebook(props) {
  return (
    <Icon {...props}>
      <title>Facebook</title>

      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.88816 17.5V9.74607H8.52509L8.92071 6.72333H5.88816V4.79375C5.88816 3.91887 6.1334 3.32265 7.40644 3.32265L9.02745 3.32199V0.618345C8.74712 0.582404 7.78484 0.5 6.66485 0.5C4.32613 0.5 2.725 1.90842 2.725 4.49438V6.72333H0.0800781V9.74607H2.725V17.5H5.88816Z"
        fill="currentColor"
      />
    </Icon>
  );
}
export function IconTwitter(props) {
  return (
    <Icon {...props}>
      <title>Twitter</title>
      <path
        d="M13.9432 2.05832C13.4987 2.28524 13.0069 2.42274 12.5273 2.51351C12.7549 2.47035 13.0893 2.00537 13.2234 1.81715C13.4277 1.53016 13.5977 1.20356 13.6932 0.85027C13.7058 0.822683 13.7145 0.787977 13.69 0.767509C13.6592 0.753716 13.6395 0.760835 13.6151 0.774628C13.0799 1.09855 12.5257 1.33304 11.9361 1.49946C11.8876 1.51325 11.8509 1.49946 11.8205 1.46475C11.7716 1.40246 11.7259 1.34372 11.6738 1.29567C11.4261 1.05762 11.1603 0.871183 10.8606 0.733248C10.467 0.552152 10.0371 0.47562 9.61347 0.506766C9.20092 0.537023 8.79627 0.668285 8.43026 0.883642C8.06347 1.09989 7.73612 1.40068 7.47542 1.76331C7.20604 2.13841 7.00726 2.58158 6.90551 3.05145C6.8073 3.50442 6.81519 3.95337 6.87514 4.41123C6.88421 4.48732 6.87829 4.49755 6.81716 4.48732C4.51189 4.10021 2.60101 3.16981 1.04944 1.17509C0.981993 1.08832 0.945708 1.08832 0.890492 1.18176C0.211332 2.32974 0.541052 4.17407 1.38901 5.08044C1.50221 5.20147 1.61856 5.32205 1.74358 5.4324C1.69783 5.44308 1.13344 5.37411 0.630581 5.08044C0.563138 5.03239 0.529614 5.05997 0.523304 5.14629C0.516993 5.27044 0.526459 5.38434 0.541841 5.51872C0.671993 6.68272 1.38625 7.75906 2.36476 8.1791C2.48111 8.23427 2.60929 8.28277 2.73432 8.3068C2.51148 8.36197 2.28194 8.40113 1.64262 8.34462C1.56295 8.32727 1.53258 8.37221 1.56295 8.45853C2.04333 9.93533 3.08021 10.3749 3.85678 10.6254C3.96091 10.6459 4.06463 10.6459 4.16915 10.6735C4.16284 10.6842 4.15653 10.6842 4.15061 10.6944C3.89307 11.1376 3.00014 11.4669 2.58405 11.631C1.82798 11.9296 1.00447 12.0635 0.205022 11.9745C0.0772358 11.9532 0.0504165 11.955 0.0153148 11.9745C-0.019787 11.999 0.0109763 12.0337 0.0519941 12.0707C0.214093 12.1917 0.379347 12.2989 0.547362 12.4021C1.05496 12.7056 1.58424 12.9477 2.13759 13.1199C4.99542 14.0102 8.21453 13.3561 10.3605 10.9507C12.0453 9.06188 12.6362 6.45713 12.6362 3.84881C12.6362 3.74692 12.743 3.69041 12.8065 3.63657C13.2451 3.26503 13.5985 2.82008 13.9259 2.32351C13.9992 2.21183 14 2.11305 14 2.07211V2.05876C14 2.01694 13.9992 2.0294 13.9424 2.05876L13.9432 2.05832Z"
        fill="currentColor"
      />
    </Icon>
  );
}

export function IconVideo(props) {
  return (
    <Icon {...props}>
      <title>{dictionary(dictionaryKeys.IconVideo)}</title>
      <svg fill="none">
        <g filter="url(#filter0_b_800_20341)">
          <rect
            x="1"
            y="1"
            width="21"
            height="21"
            rx="10.5"
            stroke="currentColor"
            stroke-width="2"
          />
        </g>
        <path
          d="M15.0607 10.9783C15.4563 11.2139 15.4563 11.7868 15.0607 12.0224L10.3107 14.8505C9.90567 15.0917 9.39226 14.7998 9.39226 14.3285L9.39226 8.67223C9.39226 8.20088 9.90567 7.90904 10.3107 8.15017L15.0607 10.9783Z"
          fill="currentColor"
        />
        <defs>
          <filter
            id="filter0_b_800_20341"
            x="-13.2235"
            y="-13.2235"
            width="49.4471"
            height="49.4471"
            filterUnits="userSpaceOnUse"
            clorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="6.61177" />
            <feComposite
              in2="SourceAlpha"
              operator="in"
              result="effect1_backgroundBlur_800_20341"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_backgroundBlur_800_20341"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </Icon>
  );
}

export function IconArrowSmall({ direction = "right", ...props }) {
  let rotate;

  switch (direction) {
    case "left":
      rotate = "flip-h";
      break;
    case "right":
      rotate = "";
      break;
    default:
      rotate = "";
  }
  return (
    <Icon
      {...props}
      className={clsx("arrow-small", rotate)}
      style={{
        width: "54px",
        height: "14px",
      }}
    >
      <path d="M52.6209 7.62093C52.9639 7.278 52.9639 6.72201 52.6209 6.37908L47.0326 0.790723C46.6896 0.447793 46.1336 0.447793 45.7907 0.790723C45.4478 1.13365 45.4478 1.68965 45.7907 2.03258L50.7581 7L45.7907 11.9674C45.4478 12.3104 45.4478 12.8664 45.7907 13.2093C46.1336 13.5522 46.6896 13.5522 47.0326 13.2093L52.6209 7.62093ZM-7.67681e-08 7.87813L52 7.87813L52 6.12188L7.67681e-08 6.12187L-7.67681e-08 7.87813Z" />
    </Icon>
  );
}

export function IconLanguage(props) {
  return (
    <Icon {...props}>
      <title>{dictionary(dictionaryKeys.IconLanguage)}</title>
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" className={"lang"} aria-hidden="true">
        <path
          d="M6.46414 13.3573C5.58071 13.3573 4.74576 13.1819 3.95929 12.831C3.17282 12.4806 2.48611 12.002 1.89917 11.3951C1.31179 10.7887 0.848527 10.0792 0.509375 9.26664C0.169792 8.45407 0 7.59141 0 6.67866C0 5.75478 0.169792 4.88944 0.509375 4.08266C0.848527 3.27544 1.31179 2.56861 1.89917 1.96219C2.48611 1.35532 3.17282 0.876462 3.95929 0.52561C4.74576 0.175203 5.58071 0 6.46414 0C7.35835 0 8.19589 0.175203 8.97676 0.52561C9.75806 0.876462 10.4422 1.35532 11.0291 1.96219C11.6165 2.56861 12.0798 3.27544 12.4189 4.08266C12.7585 4.88944 12.9283 5.75478 12.9283 6.67866C12.9283 7.59141 12.7585 8.45407 12.4189 9.26664C12.0798 10.0792 11.6165 10.7887 11.0291 11.3951C10.4422 12.002 9.75806 12.4806 8.97676 12.831C8.19589 13.1819 7.35835 13.3573 6.46414 13.3573ZM6.46414 11.9882C6.74426 11.5875 6.98666 11.1701 7.19136 10.7359C7.39606 10.3018 7.56305 9.83989 7.69233 9.35012H5.23596C5.36524 9.83989 5.53223 10.3018 5.73693 10.7359C5.94163 11.1701 6.18403 11.5875 6.46414 11.9882ZM4.78347 11.721C4.58954 11.3537 4.41997 10.9724 4.27474 10.577C4.12908 10.1821 4.00777 9.7731 3.91081 9.35012H2.00388C2.31632 9.90667 2.70675 10.3909 3.17519 10.8027C3.64405 11.2146 4.18015 11.5207 4.78347 11.721ZM8.14482 11.721C8.74814 11.5207 9.28402 11.2146 9.75245 10.8027C10.2213 10.3909 10.612 9.90667 10.9244 9.35012H9.01748C8.92052 9.7731 8.79942 10.1821 8.65419 10.577C8.50854 10.9724 8.33875 11.3537 8.14482 11.721ZM1.45443 8.01439H3.65224C3.61992 7.79177 3.59557 7.57182 3.5792 7.35454C3.56325 7.1377 3.55528 6.91241 3.55528 6.67866C3.55528 6.4449 3.56325 6.21961 3.5792 6.00278C3.59557 5.7855 3.61992 5.56555 3.65224 5.34293H1.45443C1.40056 5.56555 1.36006 5.7855 1.33291 6.00278C1.30619 6.21961 1.29283 6.4449 1.29283 6.67866C1.29283 6.91241 1.30619 7.1377 1.33291 7.35454C1.36006 7.57182 1.40056 7.79177 1.45443 8.01439ZM4.94507 8.01439H7.98322C8.01554 7.79177 8.03989 7.57182 8.05626 7.35454C8.07221 7.1377 8.08018 6.91241 8.08018 6.67866C8.08018 6.4449 8.07221 6.21961 8.05626 6.00278C8.03989 5.7855 8.01554 5.56555 7.98322 5.34293H4.94507C4.91275 5.56555 4.88862 5.7855 4.87267 6.00278C4.8563 6.21961 4.84811 6.4449 4.84811 6.67866C4.84811 6.91241 4.8563 7.1377 4.87267 7.35454C4.88862 7.57182 4.91275 7.79177 4.94507 8.01439ZM9.27605 8.01439H11.4739C11.5277 7.79177 11.5682 7.57182 11.5954 7.35454C11.6221 7.1377 11.6355 6.91241 11.6355 6.67866C11.6355 6.4449 11.6221 6.21961 11.5954 6.00278C11.5682 5.7855 11.5277 5.56555 11.4739 5.34293H9.27605C9.30837 5.56555 9.3325 5.7855 9.34844 6.00278C9.36482 6.21961 9.37301 6.4449 9.37301 6.67866C9.37301 6.91241 9.36482 7.1377 9.34844 7.35454C9.3325 7.57182 9.30837 7.79177 9.27605 8.01439ZM9.01748 4.00719H10.9244C10.612 3.45064 10.2213 2.96644 9.75245 2.55459C9.28402 2.14274 8.74814 1.83663 8.14482 1.63627C8.33875 2.0036 8.50854 2.38473 8.65419 2.77966C8.79942 3.17503 8.92052 3.58421 9.01748 4.00719ZM5.23596 4.00719H7.69233C7.56305 3.51743 7.39606 3.05549 7.19136 2.62137C6.98666 2.18726 6.74426 1.76984 6.46414 1.36912C6.18403 1.76984 5.94163 2.18726 5.73693 2.62137C5.53223 3.05549 5.36524 3.51743 5.23596 4.00719ZM2.00388 4.00719H3.91081C4.00777 3.58421 4.12908 3.17503 4.27474 2.77966C4.41997 2.38473 4.58954 2.0036 4.78347 1.63627C4.18015 1.83663 3.64405 2.14274 3.17519 2.55459C2.70675 2.96644 2.31632 3.45064 2.00388 4.00719Z"
          fill="currentColor"
        />
      </svg>
    </Icon>
  );
}

export function IconTool(props) {
  return (
    <Icon
      {...props}
      style={{
        width: "13px",
        height: "13px",
      }}
    >
      <title>{dictionary(dictionaryKeys.IconTool)}</title>
      <svg
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M11.6378 13.1347L6.89739 8.60805C6.63622 8.70699 6.37191 8.7812 6.10446 8.83067C5.83649 8.88014 5.55233 8.90488 5.25198 8.90488C3.94609 8.90488 2.83608 8.472 1.92196 7.60625C1.00784 6.7405 0.550781 5.68923 0.550781 4.45244C0.550781 4.00719 0.616076 3.58347 0.746664 3.18127C0.877253 2.77956 1.06008 2.39937 1.29514 2.0407L4.15503 4.74927L5.56539 3.41354L2.7055 0.704969C3.0842 0.482347 3.48563 0.309197 3.90979 0.185518C4.33446 0.0618394 4.78186 0 5.25198 0C6.55786 0 7.66787 0.432876 8.58199 1.29863C9.49611 2.16438 9.95317 3.21565 9.95317 4.45244C9.95317 4.7369 9.92705 5.00578 9.87482 5.25907C9.82258 5.51286 9.74423 5.76343 9.63976 6.01079L14.4193 10.5003C14.576 10.6487 14.6544 10.8281 14.6544 11.0383C14.6544 11.2486 14.576 11.4279 14.4193 11.5763L12.7739 13.1347C12.6172 13.2831 12.4278 13.3573 12.2058 13.3573C11.9838 13.3573 11.7945 13.2831 11.6378 13.1347ZM12.2058 11.5578L12.7347 11.0569L7.7201 6.30762C7.95516 6.06026 8.12493 5.77259 8.2294 5.44459C8.33387 5.11709 8.38611 4.78637 8.38611 4.45244C8.38611 3.71037 8.13485 3.06402 7.63235 2.5134C7.12932 1.96328 6.50563 1.63256 5.76127 1.52125L7.21081 2.89408C7.36751 3.0425 7.44587 3.21565 7.44587 3.41354C7.44587 3.61142 7.36751 3.78457 7.21081 3.93299L4.7035 6.30762C4.5468 6.45604 4.36397 6.53024 4.15503 6.53024C3.94609 6.53024 3.76326 6.45604 3.60656 6.30762L2.15702 4.93479C2.27455 5.63975 2.62401 6.2302 3.20539 6.70611C3.78625 7.18252 4.46844 7.42073 5.25198 7.42073C5.59151 7.42073 5.93104 7.37126 6.27057 7.27232C6.6101 7.17337 6.91698 7.01877 7.19122 6.80852L12.2058 11.5578Z"
          fill="#001E5A"
        />
      </svg>
    </Icon>
  );
}

export function IconSearch(props) {
  return (
    <Icon {...props}>
      <title>Search</title>
      <path d="M12.0536 13.3573L7.52871 8.68225C7.16959 8.97908 6.75661 9.21407 6.28975 9.38722C5.8229 9.56037 5.32612 9.64695 4.79941 9.64695C3.49461 9.64695 2.39044 9.18019 1.48689 8.24666C0.582871 7.31263 0.130859 6.17157 0.130859 4.82347C0.130859 3.47538 0.582871 2.33431 1.48689 1.40029C2.39044 0.466764 3.49461 0 4.79941 0C6.10421 0 7.20862 0.466764 8.11264 1.40029C9.01618 2.33431 9.46795 3.47538 9.46795 4.82347C9.46795 5.36766 9.38416 5.88093 9.21657 6.36328C9.04898 6.84562 8.82154 7.27232 8.53425 7.64335L13.0591 12.3184L12.0536 13.3573ZM4.79941 8.1628C5.6972 8.1628 6.46045 7.83827 7.08915 7.1892C7.71737 6.53964 8.03148 5.75107 8.03148 4.82347C8.03148 3.89588 7.71737 3.10731 7.08915 2.45775C6.46045 1.80868 5.6972 1.48415 4.79941 1.48415C3.90161 1.48415 3.13836 1.80868 2.50966 2.45775C1.88144 3.10731 1.56734 3.89588 1.56734 4.82347C1.56734 5.75107 1.88144 6.53964 2.50966 7.1892C3.13836 7.83827 3.90161 8.1628 4.79941 8.1628Z" />
    </Icon>
  );
}

export function IconHamburger(props) {
  return (
    <Icon
      {...props}
      style={{
        width: "30px",
        height: "22px",
      }}
    >
      <title>{dictionary(dictionaryKeys.IconMenu)}</title>
      <svg
        width="30"
        height="22"
        viewBox="0 0 30 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="30" height="2" fill="#001E5A" />
        <rect y="10" width="30" height="2" fill="#001E5A" />
        <rect y="20" width="30" height="2" fill="#001E5A" />
      </svg>
    </Icon>
  );
}

export function IconClose(props) {
  return (
    <Icon {...props}>
      <title>{dictionary(dictionaryKeys.IconClose)}</title>
      <path
        d="M9.56861 9.06861C9.05421 9.583 9.05421 10.417 9.56861 10.9314L17.9511 19.3139C18.4655 19.8283 19.2995 19.8283 19.8139 19.3139C20.3283 18.7995 20.3283 17.9655 19.8139 17.4511L12.3628 10L19.8139 2.54886C20.3283 2.03447 20.3283 1.20047 19.8139 0.686077C19.2995 0.171684 18.4655 0.171684 17.9511 0.686077L9.56861 9.06861ZM12 8.68281H10.5V11.3172H12V8.68281Z"
        fill="#0056DA"
      />
      <path
        d="M11.4314 9.06861C11.9458 9.583 11.9458 10.417 11.4314 10.9314L3.04886 19.3139C2.53447 19.8283 1.70047 19.8283 1.18608 19.3139C0.671684 18.7995 0.671684 17.9655 1.18608 17.4511L8.63722 10L1.18608 2.54886C0.671684 2.03447 0.671684 1.20047 1.18608 0.686077C1.70047 0.171684 2.53447 0.171684 3.04886 0.686077L11.4314 9.06861ZM9 8.68281H10.5V11.3172H9V8.68281Z"
        fill="#0056DA"
      />
    </Icon>
  );
}

export function IconPlay(props) {
  return (
    <Icon {...props}>
      <title role="image">{dictionary(dictionaryKeys.IconPlay)}</title>
      <svg
        width="120"
        height="118"
        viewBox="0 0 120 118"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        focusable="true"
      >
        <g filter="url(#filter0_b_800_23189)">
          <rect width="120" height="117.219" rx="58.6097" fill="currentColor" />
        </g>
        <path
          d="M71.0332 57.5974C71.8095 58.0489 71.8095 59.1702 71.0332 59.6216L55.9523 68.3927C55.1717 68.8466 54.1928 68.2835 54.1928 67.3806L54.1928 49.8385C54.1928 48.9356 55.1717 48.3724 55.9523 48.8264L71.0332 57.5974Z"
          fill="white"
        />
        <defs>
          <filter
            id="filter0_b_800_23189"
            x="-46.8333"
            y="-46.8333"
            width="213.667"
            height="210.886"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="23.4167" />
            <feComposite
              in2="SourceAlpha"
              operator="in"
              result="effect1_backgroundBlur_800_23189"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_backgroundBlur_800_23189"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </Icon>
  );
}

export function IconMapPin(props) {
  return (
    <Icon {...props}>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.885 11.6911C13.2787 11.6911 13.6635 11.5744 13.9909 11.3557C14.3182 11.137 14.5734 10.8261 14.724 10.4624C14.8747 10.0986 14.9141 9.6984 14.8373 9.31228C14.7605 8.92615 14.5709 8.57147 14.2925 8.29309C14.0141 8.01471 13.6595 7.82513 13.2733 7.74832C12.8872 7.67152 12.487 7.71094 12.1233 7.8616C11.7595 8.01226 11.4487 8.26739 11.2299 8.59473C11.0112 8.92207 10.8945 9.30692 10.8945 9.70061C10.8945 10.2285 11.1042 10.7348 11.4775 11.1081C11.8508 11.4814 12.3571 11.6911 12.885 11.6911ZM12.1784 18.5685C12.2709 18.6617 12.381 18.7358 12.5022 18.7863C12.6235 18.8368 12.7536 18.8629 12.885 18.8629C13.0164 18.8629 13.1465 18.8368 13.2678 18.7863C13.389 18.7358 13.4991 18.6617 13.5916 18.5685L17.6623 14.4879C18.6077 13.5429 19.2517 12.3388 19.5128 11.0278C19.7738 9.71677 19.6402 8.3578 19.1288 7.12276C18.6174 5.88771 17.7512 4.83207 16.6398 4.08935C15.5284 3.34663 14.2217 2.9502 12.885 2.9502C11.5483 2.9502 10.2416 3.34663 9.13016 4.08935C8.01876 4.83207 7.15258 5.88771 6.6412 7.12276C6.12982 8.3578 5.9962 9.71677 6.25724 11.0278C6.51828 12.3388 7.16225 13.5429 8.10771 14.4879L12.1784 18.5685ZM8.13757 9.24279C8.20557 8.53318 8.43119 7.84771 8.79795 7.23644C9.16472 6.62517 9.66336 6.10352 10.2575 5.70959C11.038 5.19712 11.9513 4.92408 12.885 4.92408C13.8187 4.92408 14.732 5.19712 15.5125 5.70959C16.1027 6.10217 16.5985 6.62066 16.9643 7.22775C17.3302 7.83485 17.5569 8.51548 17.6283 9.22068C17.6997 9.92589 17.6139 10.6381 17.3771 11.3062C17.1404 11.9743 16.7585 12.5816 16.259 13.0845L12.885 16.4585L9.51104 13.0845C9.01094 12.5865 8.62816 11.9833 8.39057 11.3187C8.15298 10.6542 8.06655 9.94497 8.13757 9.24279ZM19.8519 20.8476H5.91812C5.65416 20.8476 5.40101 20.9525 5.21436 21.1391C5.02771 21.3258 4.92285 21.5789 4.92285 21.8429C4.92285 22.1068 5.02771 22.36 5.21436 22.5466C5.40101 22.7333 5.65416 22.8382 5.91812 22.8382H19.8519C20.1158 22.8382 20.369 22.7333 20.5556 22.5466C20.7423 22.36 20.8471 22.1068 20.8471 21.8429C20.8471 21.5789 20.7423 21.3258 20.5556 21.1391C20.369 20.9525 20.1158 20.8476 19.8519 20.8476Z"
          fill="currentColor"
        />
      </svg>
    </Icon>
  );
}
